module.exports = __webpack_public_path__ + "img/img-1.fe8ea490.webp";